import { useCallback, useEffect, useRef, useState } from 'react';
import { playerRepository } from '../../data/playerRepository';
import { campanhaParaMidia, type MidiaCampanha } from '../../domain/usecases/campanhasPlayer';
import { urlMidiaPermitida } from '../../domain/usecases/validarPayloadRealtime';

const RECARGA_MS = 30 * 60_000;

/** Campanhas da plataforma que valem para esta TV; o alcance é decidido no servidor. */
export function useCampanhasPlataforma(telaId: string | undefined) {
  const [estado, setEstado] = useState<{ reservaPct: number; campanhas: MidiaCampanha[] }>({ reservaPct: 0, campanhas: [] });
  const seqRef = useRef(0);

  const recarregar = useCallback(() => {
    if (!telaId) return;
    const sequencia = ++seqRef.current;
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
    playerRepository.listarCampanhas(telaId)
      .then((resposta) => {
        if (sequencia !== seqRef.current) return;
        if (!resposta) {
          setEstado({ reservaPct: 0, campanhas: [] });
          return;
        }
        const campanhas = resposta.campanhas
          .filter((campanha) => urlMidiaPermitida(campanha.url, supabaseUrl))
          .map((campanha) => campanhaParaMidia(campanha, telaId));
        // Mesma lista = mesma referência: lista nova reiniciaria o revezamento da barra
        // e o temporizador do slideshow a cada recarga.
        setEstado((anterior) => ({
          reservaPct: resposta.reservaPct,
          campanhas: JSON.stringify(anterior.campanhas) === JSON.stringify(campanhas) ? anterior.campanhas : campanhas,
        }));
      })
      .catch((erro) => console.warn('[useCampanhasPlataforma] mantendo a última lista:', erro));
  }, [telaId]);

  useEffect(() => {
    recarregar();
    const intervalo = setInterval(recarregar, RECARGA_MS);
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') recarregar();
    };
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, [recarregar]);

  return { ...estado, recarregar };
}
